<template>
  <div>
    <h6 @click="toggleCollapse" class="variation-listing-filters-group-name">
      {{ group.variationGroupName }}
      <button class="variation-listing-filters-group-collapse-btn">
        <em :class="['ti-close', { 'ti-angle-down': !collapsed, 'ti-angle-up': collapsed }]"></em>
      </button>
    </h6>
    <transition name="collapse-fade">
      <div
        v-if="!collapsed"
        class="variation-listing-filters-variation-entries"
        :class="getVariationEntriesClassName"
      >
        <EntryFilter
          v-for="variationEntry in entries"
          :key="variationEntry.id"
          :entry="variationEntry"
          :group="group"
          class="variation-listing-filters-variation-entry"
        >
        </EntryFilter>
      </div>
    </transition>
  </div>
</template>

<script>

import EntryFilter from './EntryFilter'

export default {
  name: 'GroupFilter',
  components: {
    EntryFilter
  },
  data () {
    return {
      collapsed: false
    }
  },
  props: {
    group: {
      variationDisplayType: '',
      variationGroupId: '',
      variationGroupName: null,
      variationGroupStep: 0,
      variationGroupDisplayPosition: 0,
      variations: []
    },
    entries: {
      type: Array
    },
    isBaseGroup: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    getVariationEntriesClassName () {
      let className = ''
      if (!this.isBaseGroup) {
        className += 'range_group '
      }
      className += this.group.variationDisplayType
      if (this.collapsed) {
        className += ' collapsed'
      }
      return className
    }
  },
  methods: {
    toggleCollapse () {
      this.collapsed = !this.collapsed
    }
  }
}
</script>

<style lang="scss" scoped>
.variation-listing-filters-group-collapse-btn {
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  text-align: center;
  background: unset;
  border: unset;
}
.ti-close {
  font-size: 14px;
}
.collapse-fade-enter-active, .collapse-fade-leave-active {
  transition: opacity 0.5s;
}
.collapse-fade-enter, .collapse-fade-leave-to {
  opacity: 0;
}
</style>
